/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LanguageLevel } from './';
import {
    LanguageLevelFromJSON,
    LanguageLevelFromJSONTyped,
    LanguageLevelToJSON,
} from './';

/**
 * 
 * @export
 * @interface LanguageAndLevel
 */
export interface LanguageAndLevel {
    /**
     * 
     * @type {string}
     * @memberof LanguageAndLevel
     */
    languageCode: string;
    /**
     * 
     * @type {LanguageLevel}
     * @memberof LanguageAndLevel
     */
    languageLevel?: LanguageLevel;
}

/**
 * Check if a given object implements the LanguageAndLevel interface.
 */
export function instanceOfLanguageAndLevel(value: object): value is LanguageAndLevel {
    if (!('languageCode' in value) || value['languageCode'] === undefined) return false;
    return true;
}

export function LanguageAndLevelFromJSON(json: any): LanguageAndLevel {
    return LanguageAndLevelFromJSONTyped(json, false);
}

export function LanguageAndLevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LanguageAndLevel {
    if (json == null) {
        return json;
    }
    return {
        
        'languageCode': json['languageCode'],
        'languageLevel': json['languageLevel'] == null ? undefined : LanguageLevelFromJSON(json['languageLevel']),
    };
}

export function LanguageAndLevelToJSON(value?: LanguageAndLevel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'languageCode': value['languageCode'],
        'languageLevel': LanguageLevelToJSON(value['languageLevel']),
    };
}

